"use client";
import React from "react";
import { ElementHighlighter } from "../../ElementHighlighter";
import { ElementTagLabel } from "../ElementTagLabel";

interface HoveredElementProps {
  hoveredElement: HTMLElement | null;
  elementLabel?: (element: HTMLElement) => React.ReactNode;
  highlighterStyle?: React.CSSProperties;
}

export const HoveredElement: React.FC<HoveredElementProps> = ({
  hoveredElement,
  elementLabel,
  highlighterStyle,
}) => {
  if (!hoveredElement) return null;

  return (
    <ElementHighlighter
      element={hoveredElement}
      borderColor="rgba(59, 130, 246, 0.8)" // Blue border
      // backgroundColor="rgba(59, 130, 246, 0.2)" // Light blue background
      style={highlighterStyle}
    >
      {elementLabel ? (
        elementLabel(hoveredElement)
      ) : (
        <ElementTagLabel element={hoveredElement} />
      )}
    </ElementHighlighter>
  );
};
